module.exports = __webpack_public_path__ + "static/media/end.212c3e3d.png";